import Component from '@glimmer/component'
import { LinkTo } from '@ember/routing'

interface Signature {
  Element: HTMLDivElement
  Args: {
    activity_id: string
    title: string
    thumbnail: string
    tags: string[]
    filteredTag?: Nullable<string>
  }
}
export class ExcitingWritingIdeasCatalogueCard extends Component<Signature> {
  get thumbnailUrl() {
    return `https://cdn-editor.writinglegends.com/${this.args.thumbnail}`
  }

  get tagToShow() {
    const { filteredTag, tags } = this.args
    const primaryTag = tags[0] ?? null

    // If there's a filtered tag and it's included in the tags for this activity, show it. Otherwise, show the primary tag.
    if (filteredTag && tags.includes(filteredTag)) {
      return filteredTag
    }

    return primaryTag
  }

  get tagColorClass() {
    const tag = this.tagToShow

    switch (tag) {
      case 'Informative Texts':
        return 'bg-oceany-blue-350'
      case 'Persuasive Texts':
        return 'bg-purply-pink-300'
      case 'Imaginative Texts':
        return 'bg-juicy-orange-450'
      default:
        return 'bg-green-350'
    }
  }
  <template>
    <LinkTo
      @route="subscription-type.writing-ideas.previews"
      @model={{@activity_id}}
      class="border-grey-500 bg-wl-blue-300 relative flex flex-col pt-4 text-center lg:w-56"
    >
      <div class="absolute inset-x-0 -top-4"><span
          data-testid="text-type"
          class="inline-block rounded-full px-3 text-sm leading-7 text-white [text-shadow:0_1px_2px_rgba(0,0,0,0.25)]
            {{this.tagColorClass}}"
        >{{this.tagToShow}}</span></div>
      <img src={{this.thumbnailUrl}} alt="{{@title}}" class="h-40 w-full object-contain" />
      <span
        data-testid="title"
        class="text-wl-blue-300 m-px inline-flex flex-1 items-center justify-center bg-white px-2 py-1 text-lg leading-5"
      >{{@title}}</span>
    </LinkTo>
  </template>
}
